import { render, staticRenderFns } from "./image-tab.vue?vue&type=template&id=cae7cb96&scoped=true"
import script from "./image-tab.vue?vue&type=script&lang=js"
export * from "./image-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae7cb96",
  null
  
)

export default component.exports